import * as _ from 'lodash';
import moment from 'moment';

var rawStatus = function(order) {
  if (order.state == 'accepted') {
    return 'Accepted';
  } else if (order.state == 'rejected') {
    return 'Rejected';
  } else if (order.state == 'pending') {
    return 'Pending';
  } else if (order.state == 'pending_rejection') {
    return 'Pending Rejection';
  }
};

var hasBackorderedProducts = function(order) {
  // Check if this property exists on the passed in order
  if (order.has_backordered_products == true) { return true; }

  var products = order.products || order.order_products || [];

  return _.some(products, function(p) { return p.backordered; });
};

var orderStatus = function(order, opts={}) {
  var state = [];

  state.push(rawStatus(order));

  if (order.state == 'accepted' && hasBackorderedProducts(order)) {
    state.push('With Back Orders');
  };

  if (opts.without_time != true && order.state != 'pending') {
    state.push(moment(order.actioned_at).fromNow());
  };

  return state.join(' ').trim();
};


var orderStateWithoutTimeRetailer = function(order) {
  if (order.state == 'pending_rejection') {
    return 'Pending';
  } else {
    return orderStatus(order, { without_time: true });
  };
}

var orderInStockProductsRatio = function(order) {
  return `(${order.in_stock_count} / ${order.product_count} products)`;
}

var orderInStockItemsAccepted = function(order) {
  return `${order.in_stock_count} / ${order.product_count} items accepted`;
}

var orderProductIsNotAvailable = function (orderProduct) {
  return !!orderProduct.out_of_stock || !!orderProduct.removed_by_rep || !!orderProduct.backordered;
};

var service = function(Flash, $timeout, $rootScope) {
  var calcVsPrevious = function(current, previous) {
    if (!current || !previous) {
      return {percent: 'N/A', direction: 'N/A'};
    }
    var percent = 100 * ((current - previous) / previous);
    var direction = percent > 0 ? 'UP' : 'DOWN';
    return {percent: Math.abs(percent.toFixed(2)), direction: direction};
  };

  var orderAnalytics = function(orderAnalyticsData) {
    let result = {};
    result.last_month = {
      total: orderAnalyticsData.total_month || 0,
      name: 'MONTH'
    };
    result.last_month.vs_previous = calcVsPrevious(orderAnalyticsData.total_month,
                                                      orderAnalyticsData.total_previous_month);
    result.last_quarter = {
      total: orderAnalyticsData.total_quarter || 0,
      name: 'QUARTER'
    };
    result.last_quarter.vs_previous = calcVsPrevious(orderAnalyticsData.total_quarter,
                                                           orderAnalyticsData.total_previous_quarter);
    result.last_year = orderAnalyticsData.total_year || 0;
    return result;
  };

  // only works when calling order products index hook with full_products=true
  var orderProductsFromOrders = function(orders, n) {
    var result = [];
    var foundPls = {};
    for (var i = 0; i < orders.length; i++) {
      var distributor = orders[i].distributor;
      for (var j = 0; j < orders[i].products.length; j++) {
        if (result.length === n) {
          return result;
        }
        var product = orders[i].products[j];
        product.distributor_name = distributor.name;
        if (!foundPls[product.product_line_id]) {
          result.push(product);
          foundPls[product.product_line_id] = 1;
        }
      }
    }
    return result;
  };

  var orderContentsDesc = function(order) {
    var output = [];
    if(order.unit_count) output.push('' + order.unit_count + ' unit' + (order.unit_count > 1 ? 's' : ''));
    if(order.case_count) output.push('' + order.case_count + ' case' + (order.case_count > 1 ? 's' : ''));
    if(order.keg_count) output.push('' + order.keg_count + ' keg' + (order.keg_count > 1 ? 's' : ''));
    if(order.box_count) output.push('' + order.box_count + ' box' + (order.box_count > 1 ? 'es' : ''));
    return output.join(', ');
  };

  var sumStatuses = function(orderGroup) {
    orderGroup.numUnseen = _.filter(orderGroup.orders, function(o) { return !o.seen_by_rep_at; }).length;
    orderGroup.numSeen = _.filter(orderGroup.orders, function(o) { return o.seen_by_rep_at; }).length;
    orderGroup.numAccepted = _.filter(orderGroup.orders, function(o) { return o.state == 'accepted'; }).length;
    orderGroup.numRejected = _.filter(orderGroup.orders, function(o) { return o.state == 'rejected'; }).length;
    if (!orderGroup.orders) { return; }
    orderGroup.numOrders = orderGroup.orders.length;
  };

  return {
    orderStatus: orderStatus,
    rawStatus: rawStatus,
    orderAnalytics: orderAnalytics,
    orderProductsFromOrders: orderProductsFromOrders,
    orderContentsDesc: orderContentsDesc,
    sumStatuses: sumStatuses,
    orderProductIsNotAvailable: orderProductIsNotAvailable,
  };
};

service.$inject = ['Flash', '$timeout', '$rootScope'];

tiz.service('Order', service);

export default {
  rawStatus: rawStatus,
  orderStateWithoutTimeRetailer: orderStateWithoutTimeRetailer,
  orderStatus: orderStatus,
  orderInStockProductsRatio: orderInStockProductsRatio,
  orderInStockItemsAccepted: orderInStockItemsAccepted,
  orderProductIsNotAvailable: orderProductIsNotAvailable,
};
